// Re-export service types from centralized services data
export { SERVICE_TYPES, type ServiceType } from "./services-data";

export const BUDGET_RANGES = [
  "Under £1,000",
  "£1,000 - £2,500",
  "£2,500 - £5,000",
  "£5,000 - £10,000",
  "£10,000+",
] as const;

export type BudgetRange = typeof BUDGET_RANGES[number];

// Toggle visibility of phone & WhatsApp contact methods across the site
export const SHOW_PHONE_CONTACT = false;

// Centralized contact information
export const CONTACT_INFO = {
  email: "hello@prezmedia.co.uk",
  phone: "+44 7446 233 008",
  phoneRaw: "+447446233008",
  whatsappLink: "https://wa.me/447446233008",
  location: "United Kingdom",
  socials: {
    instagram: "https://www.instagram.com/officialprezmedia",
    youtube: "https://www.youtube.com/@officialprezmedia",
    tiktok: "https://www.tiktok.com/@officialprezmedia",
  },
} as const;
